import { Component, OnInit, Input } from '@angular/core'
import { SignupFormProxy } from '../signup/signup-form-factory'

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {
  @Input() public parentForm: SignupFormProxy
  @Input() public validate: boolean = false

  private _isPasswordVisible: boolean = false

  public constructor() { }

  public ngOnInit() { }

  public get isPasswordVisible() {
    return this._isPasswordVisible
  }

  public toggleVisibility() {
    this._isPasswordVisible = !this._isPasswordVisible
  }
}
